import { TimePeriod } from '@hakimo-ui/hakimo/types';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { defaultFilterValues } from './constants';
import { defaultVisibleColumns } from './location-incidents-list/utils';

export type ProductType = 'rg' | 'scan';

export const locationIncidentsTimePeriodAtom = atomWithStorage<TimePeriod>(
  'locationIncidents/timePeriod',
  TimePeriod.PAST_24_HOURS
);

export const locationIncidentsFiltersAtom = atomWithStorage(
  'locationIncidents/filters',
  defaultFilterValues
);

export const locationIncidentsPageAtom = atom<number>(1);
export const locationIncidentsPageSizeAtom = atom<number>(20);

export const locationIncidentsProductTypeAtom = atomWithStorage<ProductType>(
  'locationIncidents/productType',
  'rg'
);

// Shared across RG and Scan since columns are unified.
export const locationIncidentsShownColumnsAtom = atomWithStorage<string[]>(
  'locationIncidents/shownColumns',
  defaultVisibleColumns
);
